var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 14,
    viewBox: "0 0 20 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.1429 13.6975C18.7189 13.6929 19.9954 12.4164 20 10.8403V2.85714C19.9954 1.2811 18.7189 0.00461508 17.1429 0H2.85714C1.2811 0.00461508 0.00461508 1.2811 0 2.85714V10.8403C0.00461508 12.4164 1.2811 13.6929 2.85714 13.6975H17.1429ZM13.3403 6.4958L7.93277 9.29412V3.69748L13.3403 6.4958Z",
    fill: "#AEAEAE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.6c13db038a241295d02e855bb70135b9.svg";
export { ForwardRef as ReactComponent };